<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMerchants"
      :refresh-table="getData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
    <template v-slot:top>
      <TableTopInputerHistory
        :loading="loading"
        @refresh="getData"
        @export="exportExcel"
      />
    </template>
      <template v-slot:body-prepend>
        <TableFilterInputerHistory :search.sync="search" :options.sync="options" v-on:getDataParent="getData" />
      </template>
      <template slot="action" slot-scope="{ item }">
      <div class="d-flex justify-center align-center" style="height: 100%">
        <v-icon
          @click="viewItem(item)"
          size="20"
        >
          mdi-eye
        </v-icon>
      </div>
    </template>
      </TableView>
  </v-card>
</template>

<script>
import inputerHistoryMixin from '@components/daftar-tugas/inputer-history/inputerHistoryMixin';
import { TableFilterInputerHistory, TableTopInputerHistory } from '@components/daftar-tugas/inputer-history/components';

export default {
  mixins: [inputerHistoryMixin],
  components: {
    TableView: () => import("@components/@drontVue/components/Table/TableView.vue"),
    TableFilterInputerHistory,
    TableTopInputerHistory
  },
};
</script>